export const destination_card_locale = {
  DESTINATION: "Destination",
  CONTACT_GREETINGS: "Kind Attention",
  CONTACT: "Contact",
  PHONE: "Phone"
};
